import { LitElement, html, svg } from 'lit';

export class IconUp16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Kvadrat med pil opp</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM8 4.5V12"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 6.5 8 4l3 2.5"></path></svg>`; }
}
if (!customElements.get('f-icon-up16', IconUp16)) {
  customElements.define('f-icon-up16', IconUp16);
}